import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from "../../services/httpService";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    makeStyles,
    Typography,
    useMediaQuery,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Grid,
    FormControl,
    Modal,
    IconButton,
    FormControlLabel,
    Checkbox,
    TablePagination,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { CSVLink } from "react-csv";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import {
    IoMdArrowDroprightCircle,
    IoMdArrowDropdownCircle,
} from "react-icons/io";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";


const useStyles = makeStyles(() => ({
    paperWrapper: {
        padding: "2rem",
        borderRadius: "10px",
        boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        marginBottom: "1.5rem",
    },
    tableContainer: {
        maxHeight: 688,
        overflow: "auto",
    },
    title: {
        fontWeight: 700,
        color: "#1e293b",
        marginBottom: "16px",
        textAlign: "center",
        fontSize: "20px",
    },
    headerCell: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        borderRight: "1px solid rgba(255,255,255,0.2)",
        borderBottom: "1px solid #fff",
        position: "sticky",
        top: 0,
        zIndex: 2,
    },
    topLeftHeader: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        padding: "16px",
        borderRight: "1px solid rgba(255,255,255,0.2)",
        borderBottom: "1px solid #fff",
        position: "sticky",
        top: 0,
        left: 0,
        zIndex: 5,
    },
    monthCell: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        padding: "16px",
        border: "1px solid #ddd",
        position: "sticky",
        left: 0,
        zIndex: 3,
    },
    bodyCell: {
        textAlign: "center",
        fontSize: "14px",
        padding: "16px",
        border: "1px solid #ddd",
        color: "#263238",
        backgroundColor: "#fff",
    },
    button: {
        fontSize: "12px",
        textTransform: "none",
    },
    modalWrapper: {
        backgroundColor: "white",
        padding: 20,
        margin: "5% auto",
        width: "90%",
        maxHeight: "90vh",
        overflowY: "auto",
        borderRadius: 8,
    },
    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 12,
    },
    closeButton: {
        color: "#000",
        padding: 6,
    },
    csv: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 16,
        gap: 10,
    },
    tableRowEven: {
        backgroundColor: "#f9f9f9",
    },
    tableRowOdd: {
        backgroundColor: "#fff",
    },
    valueCell: {
        fontSize: "14px",
        color: "#263238",
        padding: "10px",
        border: "1px solid #ddd",
        textAlign: "center",
    },
}));

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#1C375D",
    color: "#FFF",
    fontWeight: 600,
    textAlign: "center",
  },
  body: {
    fontSize: 14,
    borderRight: "1px solid #ccc",
    textAlign: "center",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const FreezeProjects = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const csvButtonRef = useRef();
    const { userDetails } = useSelector((state) => state.user);
    const isMobile = useMediaQuery("(max-width:600px)");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [commonExpCenter, setExpCenter] = useState([]);
    const [commonLocation, setLocation] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState(
        []
    );
    const [storeDateFilter, setStoreDateFilter] = useState({
        startDate: "",
        endDate: "",
    });
    const [data, setData] = useState([]);
    const [clearTriggered, setClearTriggered] = useState(false);
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [modelData, setModelData] = useState([]);

    const [remarks, setRemarks] = useState("");
    const [freezeDate, setFreezeDate] = useState("");
    const [showProjects, setShowProjects] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [projectValue, setProjectValue] = useState(0);
    const [bottomsUpData, setBottomsUpData] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [commitBtn, setCommitBtn] = useState("");
    const [activeTab, setActiveTab] = useState("commitment");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [approvalLog, setApprovalLog] = useState([]);


    const handleChangePage = (_, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(+e.target.value);
        setPage(0);
    };

    useEffect(() => {
        if (clearTriggered) {
            monthlyContractData();
            bottomsUpDataFunction();
            getApprovalLogData();
            setClearTriggered(false);
        }
    }, [clearTriggered]);

    useEffect(() => {
        monthlyContractData();
        bottomsUpDataFunction();
        getApprovalLogData()
        expCenters();
        locations();
    }, []);

    const toggleProjectSelection = (index) => {
        setSelectedProjects((prevSelected) => {
            let updated;
            if (prevSelected.includes(index)) {
                updated = prevSelected.filter((i) => i !== index);
            } else {
                updated = [...prevSelected, index];
            }

            const total = updated.reduce(
                (sum, i) => sum + (projectList[i]?.staticSalesWonBudget || 0),
                0
            );
            setProjectValue(total.toFixed(2));
            return updated;
        });
    };

    const toggleSelectAllProjects = () => {
        if (selectedProjects.length === projectList.length) {
            setSelectedProjects([]);
            setProjectValue(0);
        } else {
            const allIndexes = projectList.map((_, idx) => idx);
            const total = projectList.reduce(
                (sum, p) => sum + (p.staticSalesWonBudget || 0),
                0
            );
            setSelectedProjects(allIndexes);
            setProjectValue(total.toFixed(2));
        }
    };

    const expCenters = async () => {
        props.setLoading(true);
        try {
            const res = await HttpService.getExpericenCenters();
            const matched = res.data.filter((e) =>
                userDetails.experienceCenterId.includes(e._id)
            );
            setExpCenter(matched);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const locations = async () => {
        props.setLoading(true);
        try {
            const res = await HttpService.getLocation();
            const matched = res.data.filter((e) =>
                userDetails.selectedLocation.includes(e._id)
            );
            setLocation(matched);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // this is for monthly contract data API.
    const monthlyContractData = async () => {
        props.setLoading(true);

        try {
            let expCenterData = selectedExperienceCenter?.map((el) => el._id);
            let locationData = selectedLocation?.map((el) => el._id);
            let userExpeData = userDetails?.experienceCenterId?.map((el) => el);

            const obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedExperienceCenter: expCenterData || [],
                selectedLocation: locationData || [],
                userId: userDetails?._id,
                userExpeCenterId: userExpeData || [],
            };

            props.setSnackInfo("Fetching Data...", "info");

            const response = await HttpService.getMonthlyContractDataforFrezz(
                obj
            );
            if (response?.status === 200) {
                const { data } = response;
                if (data) {

                    setData(data);
                    props.setSnackInfo("Data Fetched Successfully", "success");
                } else {
                    setData([]);
                    props.setSnackInfo("No Data Found", "info");
                }
            } else {
                const errMsg =
                    response?.data?.message || "Failed to Fetch Data";
                props.setSnackInfo(errMsg, "error");
            }
        } catch (error) {
            console.error("Error fetching monthly contract data:", error);

            // Extract detailed error message if available
            let message = "Something went wrong!";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            } else if (error?.message) {
                message = error.message;
            }

            props.setSnackInfo(message, "error");
        } finally {
            props.setLoading(false);
        }
    };

    // this is Bottom Up data API.
    const bottomsUpDataFunction = async () => {
        props.setLoading(true);

        try {
            let expCenterData = selectedExperienceCenter?.map((el) => el._id);
            let locationData = selectedLocation?.map((el) => el._id);
            let userExpeData = userDetails?.experienceCenterId?.map((el) => el);

            const obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedExperienceCenter: expCenterData || [],
                selectedLocation: locationData || [],
                userId: userDetails?._id,
                userExpeCenterId: userExpeData || [],
            };

            props.setSnackInfo("Fetching Data...", "info");

            const response = await HttpService.getNewMonthlyContractDataforFrezz(
                obj
            );
            if (response?.status === 200) {
                const { data } = response;
                if (data) {
                    setBottomsUpData(data);
                    props.setSnackInfo("Data Fetched Successfully", "success");
                } else {
                    setBottomsUpData([]);
                    props.setSnackInfo("No Data Found", "info");
                }
            } else {
                const errMsg =
                    response?.data?.message || "Failed to Fetch Data";
                props.setSnackInfo(errMsg, "error");
            }
        } catch (error) {
            console.error("Error fetching Bottoms Up Data:", error);

            // Extract detailed error message if available
            let message = "Something went wrong!";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            } else if (error?.message) {
                message = error.message;
            }

            props.setSnackInfo(message, "error");
        } finally {
            props.setLoading(false);
        }
    }

    // this is committed month data save API.
    const commitedMonth = async () => {
        props.setLoading(true);
        try {
            const obj = {
                remarks: remarks,
                selectedProjects: selectedProjects.map(
                    (index) => projectList[index]
                ),
                projectValue: projectValue,
                freezeDate: freezeDate,
                freezeStage: "Sent for Approval",
                commitType: commitBtn,
            };
            props.setSnackInfo("Committing Month Data...", "info");
            const response = await HttpService.freezLeads(
                obj
            );
            if (response?.status === 201) {
                const { data } = response;
                if (data) {
                    props.setSnackInfo("Leads freez Successfully", "success");
                } else {
                    props.setSnackInfo("Leads are not freez...", "info");
                }
            } else {
                const errMsg =
                    response?.data?.message || "somthing problem while leads freezing";
                props.setSnackInfo(errMsg, "error");
            }
            
        } catch (error) {
            console.error("Error while freezing leads:", error);
            let message = "Something went wrong!";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            }
            props.setSnackInfo(message, "error");
        }
        props.setLoading(false);
    }

    // this is all approval pending data log api.
    const getApprovalLogData = async () => {
        props.setLoading(true);
        try {
            let userRoles = userDetails?.roles.map((el) => el._id);
            let userExpeData = userDetails?.experienceCenterId?.map((el) => el);


            const obj = {
                userId: userDetails._id,
                userRole: userRoles || [],
                userExpeCenterId: userExpeData || [],
                pivot: activeTab,
            }
            let response = await HttpService.getAllApprovalPendingData(obj);
                
            if (response?.status === 200) {
                const { data } = response;
                if (data) {
                    setApprovalLog(data);
                    props.setSnackInfo("Data Fetched Successfully", "success");
                } else {
                    setApprovalLog([]);
                    props.setSnackInfo("No Data Found", "info");
                }
            } else {
                const errMsg =
                    response?.data?.message || "Failed to Fetch Data";
                props.setSnackInfo(errMsg, "error");
            }
        } catch (error) {
            console.error("Error fetching Bottoms Up Data:", error);

            // Extract detailed error message if available
            let message = "Something went wrong!";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            } else if (error?.message) {
                message = error.message;
            }

            props.setSnackInfo(message, "error");
        } finally {
            props.setLoading(false);
        }
    };

    const handleSubmitAllFilters = () => {
        monthlyContractData();
        bottomsUpDataFunction();
    };

    const handleClearAllFilters = () => {
        setSelectedLocation([]);
        setSelectedExperienceCenter([]);
        setStoreDateFilter({ startDate: "", endDate: "" });
        setClearTriggered(true);
    };

    const isSubmitDisabled = !(
        selectedLocation.length > 0 ||
        selectedExperienceCenter.length > 0 ||
        (storeDateFilter.startDate && storeDateFilter.endDate)
    );

    const handleOpenDialog = (data) => {
        setProjectList(data);
        setRemarks("");
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setRemarks("");
        setProjectValue(0);
        setSelectedProjects([]);
        setFreezeDate("");
        setProjectList([]);
        setShowProjects(false);
    };

    const handleSubmit = async () => {
        commitedMonth();
        bottomsUpDataFunction();
        handleCloseDialog();
        monthlyContractData();
    };

    const uniqueExperienceCenters = React.useMemo(() => {
        const set = new Set();
        Object.values(data).forEach((monthEntries) => {
            if (Array.isArray(monthEntries)) {
                monthEntries.forEach((entry) => {
                    set.add(entry.experienceCenterName);
                });
            }
        });
        // return Array.from(set);
        return Array.from(set).sort((a, b) => {
            if (a === "Total") return 1;   
            if (b === "Total") return -1; 
            return a.localeCompare(b);
        });
    }, [data]);

    const uniqueExperienceCentersBottoms = React.useMemo(() => {
        const set = new Set();
        Object.values(bottomsUpData).forEach((monthEntries) => {
            if (Array.isArray(monthEntries)) {
                monthEntries.forEach((entry) => {
                    set.add(entry.experienceCenterName);
                });
            }
        });
        // return Array.from(set);
        return Array.from(set).sort((a, b) => {
            if (a === "Total") return 1;   
            if (b === "Total") return -1; 
            return a.localeCompare(b);
        });
    }, [bottomsUpData]);

    const headers = [
        { label: "Sl. No.", key: "index" },
        { label: "Project No.", key: "projectNo" },
        { label: "Lead No.", key: "leadNo" },
        { label: "Value (INR)", key: "value" },
        { label: "City", key: "city" },
        { label: "Exp. Ctr. Name", key: "expCenter" },
        { label: "Current Stage", key: "currentStage" },
        { label: "Sales Won Date", key: "salesWonDate" },
        {
            label: "Tentative Design Closure Date (Committed Date)",
            key: "closureDate",
        },
        // {
        //     label: "Projection DSO Commited At",
        //     key: "projectionDSOCommitedUpdatedAt",
        // },
        { label: "Internal Design Sign-Off Date (IDSO)", key: "internalDesignSignOffDate" },
    ];

    const csvData = modelData.map((item, i) => ({
        _id: item?._id,
        index: i + 1,
        projectNo: item?.erpProjectNo || "N/A",
        leadNo: item?.lead_no || "N/A",
        value: item?.staticSalesWonBudget || "N/A",
        city: item?.cityName || "N/A",
        expCenter: item?.experienceCenterName || "N/A",
        currentStage:
            item?.currentStage ??
            item?.leadId?.currentStage ??
            item?.lead?.currentStage ??
            "N/A",
        salesWonDate: item?.leadWonDate
            ? moment(item?.leadWonDate).format("DD-MM-YYYY")
            : "-",
        closureDate:
            item?.closureDate
                ? moment(item?.closureDate).format(
                      "DD-MM-YYYY"
                  )
                : "-",
        // projectionDSOCommitedUpdatedAt:
        //     item?.projectionDSOCommitedUpdatedAt
        //         ? moment(item?.projectionDSOCommitedUpdatedAt).format(
        //               "DD-MM-YYYY"
        //           )
        //         : "-",
        internalDesignSignOffDate: (item?.internalDesignSignOffDate && item?.internalDesignSignOffDate)
            ? moment(item?.internalDesignSignOffDate).format("DD-MM-YYYY")
            : "-",
    }));

    const csvDownloadHandler = () => {
        if (csvButtonRef.current) {
            csvButtonRef.current.link.click();
        }
    };

    const openModel = (data) => {
        setModelData(data || []);
        setShowDetailedModal(true);
    };

    const getMaxDateEnd = () => {
        const today = new Date();
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const y = lastDay.getFullYear();
        const m = String(lastDay.getMonth() + 1).padStart(2, "0");
        const d = String(lastDay.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };


    const getMinDate = () => {
        return new Date().toISOString().split("T")[0];
    };

    // Maximum = last day of the third month from now
    const getMaxDate = () => {
        const today = new Date();
        const maxDate = new Date(today.getFullYear(), today.getMonth() + 4, 0); // 4 because we include the current month
        return maxDate.toISOString().split("T")[0];
    };


    return (
        <>
            {/*-Start--Filter Section */}
            <Paper className={classes.paperWrapper}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                multiple
                                value={selectedLocation}
                                options={commonLocation}
                                getOptionLabel={(option) => option.name}
                                onChange={(e, val) => setSelectedLocation(val)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Select Location'
                                        variant='outlined'
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                multiple
                                value={selectedExperienceCenter}
                                options={commonExpCenter}
                                getOptionLabel={(option) => option.name}
                                onChange={(e, val) =>
                                    setSelectedExperienceCenter(val)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Select Exp-Center'
                                        variant='outlined'
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label='Expected DSO From Date'
                            type='date'
                            variant='outlined'
                            value={storeDateFilter.startDate}
                            onChange={(e) =>
                                setStoreDateFilter({
                                    ...storeDateFilter,
                                    startDate: e.target.value,
                                })
                            }
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                max: getMinDate(),
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label='Expected DSO End Date'
                            type='date'
                            variant='outlined'
                            value={storeDateFilter.endDate}
                            onChange={(e) =>
                                setStoreDateFilter({
                                    ...storeDateFilter,
                                    endDate: e.target.value,
                                })
                            }
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                max: getMaxDateEnd(),
                            }}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Box mt={3} display='flex' gap={2} flexWrap='wrap'>
                    <Button
                        variant='contained'
                        color='primary'
                        style={{
                            color: "#fff",
                            padding: "6px 20px",
                            whiteSpace: "nowrap",
                            backgroundColor: isSubmitDisabled
                                ? "#cccccc"
                                : "#4caf50",
                            opacity: isSubmitDisabled ? 0.5 : 1,
                        }}
                        onClick={handleSubmitAllFilters}
                        disabled={isSubmitDisabled}>
                        Submit
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        style={{ marginLeft: "10px" }}
                        onClick={handleClearAllFilters}>
                        Clear Filter
                    </Button>
                </Box>
            </Paper>
            {/*--END---Filter Section */}

            {/* --START--Table 2 - Projection freeze for first current month */}
            <Paper className={classes.paperWrapper}>
                <Typography className={classes.title}>
                    Projection freeze for current month
                </Typography>

                <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    className={classes.topLeftHeader}
                                    rowSpan={2}>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            lineHeight: 1.4,
                                        }}>
                                        <span>Experience Center</span>
                                        <br />
                                        <span>Committed Month</span>
                                    </div>
                                </TableCell>
                                {uniqueExperienceCenters.map((center) => (
                                    <TableCell
                                        key={center}
                                        className={classes.headerCell}
                                        colSpan={3}>
                                        {center}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {uniqueExperienceCenters.map((center, idx) => (
                                    <React.Fragment key={center + idx}>
                                        <TableCell
                                            className={classes.headerCell}>
                                            Count
                                        </TableCell>
                                        <TableCell
                                            className={classes.headerCell}>
                                            Value
                                        </TableCell>
                                        <TableCell
                                            className={classes.headerCell}>
                                            Action
                                        </TableCell>
                                    </React.Fragment>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {Object.entries(data).map(
                                ([monthKey, entries], rowIndex) => {
                                    return (
                                        <TableRow key={monthKey}>
                                            <TableCell
                                                className={classes.monthCell}>
                                                {entries[0]?.month ||
                                                    monthKey.replace("_", " ")}
                                            </TableCell>
                                            {uniqueExperienceCenters.map(
                                                (center, colIndex) => {
                                                    const entry = entries.find(
                                                        (e) =>
                                                            e.experienceCenterName ===
                                                            center
                                                    );
                                                    return (
                                                        <React.Fragment
                                                            key={
                                                                center +
                                                                colIndex
                                                            }>
                                                            <TableCell
                                                                className={
                                                                    classes.bodyCell
                                                                }
                                                                style={{
                                                                    cursor: entry
                                                                        ? "pointer"
                                                                        : "default",
                                                                    fontWeight:
                                                                        "bold",
                                                                }}
                                                                onClick={() =>
                                                                    openModel(
                                                                        entry?.data
                                                                    )
                                                                }>
                                                                {entry?.count ??
                                                                    "-"}
                                                            </TableCell>
                                                            <TableCell
                                                                className={
                                                                    classes.bodyCell
                                                                }
                                                                style={{
                                                                    cursor: entry
                                                                        ? "pointer"
                                                                        : "default",
                                                                    fontWeight:
                                                                        "bold",
                                                                }}
                                                                onClick={() =>
                                                                    openModel(
                                                                        entry?.data
                                                                    )
                                                                }>
                                                                {entry?.value ??
                                                                    "-"}
                                                            </TableCell>
                                                            <TableCell
                                                                className={
                                                                    classes.bodyCell
                                                                }>
                                                                {entry ? (
                                                                    <Button
                                                                        variant='outlined'
                                                                        color='primary'
                                                                        size='small'
                                                                        className={
                                                                            classes.button
                                                                        }
                                                                        onClick={() =>{
                                                                            setCommitBtn("commit");
                                                                            handleOpenDialog(
                                                                                entry?.data
                                                                            )
                                                                        }}>
                                                                        Update
                                                                    </Button>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </TableCell>
                                                        </React.Fragment>
                                                    );
                                                }
                                            )}
                                        </TableRow>
                                    );
                                }
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            {/*--END-- Table 2 - Projection freeze for first current month */}

            {/* --START--Table 2 - New Add-on Data Freezz */}
            <Paper className={classes.paperWrapper}>
                <Typography className={classes.title}>
                    Newly added project for current month
                </Typography>

                <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    className={classes.topLeftHeader}
                                    rowSpan={2}>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            lineHeight: 1.4,
                                        }}>
                                        <span>Experience Center</span>
                                        <br />
                                        <span>Committed Month</span>
                                    </div>
                                </TableCell>
                                {uniqueExperienceCentersBottoms.map((center) => (
                                    <TableCell
                                        key={center}
                                        className={classes.headerCell}
                                        colSpan={3}>
                                        {center}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {uniqueExperienceCentersBottoms.map((center, idx) => (
                                    <React.Fragment key={center + idx}>
                                        <TableCell
                                            className={classes.headerCell}>
                                            Count
                                        </TableCell>
                                        <TableCell
                                            className={classes.headerCell}>
                                            Value
                                        </TableCell>
                                        <TableCell
                                            className={classes.headerCell}>
                                            Action
                                        </TableCell>
                                    </React.Fragment>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {Object.entries(bottomsUpData).map(
                                ([monthKey, entries], rowIndex) => {
                                    return (
                                        <TableRow key={monthKey}>
                                            <TableCell
                                                className={classes.monthCell}>
                                                {entries[0]?.month ||
                                                    monthKey.replace("_", " ")}
                                            </TableCell>
                                            {uniqueExperienceCentersBottoms.map(
                                                (center, colIndex) => {
                                                    const entry = entries.find(
                                                        (e) =>
                                                            e.experienceCenterName ===
                                                            center
                                                    );
                                                    return (
                                                        <React.Fragment
                                                            key={
                                                                center +
                                                                colIndex
                                                            }>
                                                            <TableCell
                                                                className={
                                                                    classes.bodyCell
                                                                }
                                                                style={{
                                                                    cursor: entry
                                                                        ? "pointer"
                                                                        : "default",
                                                                    fontWeight:
                                                                        "bold",
                                                                }}
                                                                onClick={() =>
                                                                    openModel(
                                                                        entry?.data
                                                                    )
                                                                }>
                                                                {entry?.count ??
                                                                    "-"}
                                                            </TableCell>
                                                            <TableCell
                                                                className={
                                                                    classes.bodyCell
                                                                }
                                                                style={{
                                                                    cursor: entry
                                                                        ? "pointer"
                                                                        : "default",
                                                                    fontWeight:
                                                                        "bold",
                                                                }}
                                                                onClick={() =>
                                                                    openModel(
                                                                        entry?.data
                                                                    )
                                                                }>
                                                                {entry?.value ??
                                                                    "-"}
                                                            </TableCell>
                                                            <TableCell
                                                                className={
                                                                    classes.bodyCell
                                                                }>
                                                                {entry ? (
                                                                    <Button
                                                                        variant='outlined'
                                                                        color='primary'
                                                                        size='small'
                                                                        className={
                                                                            classes.button
                                                                        }
                                                                        onClick={() =>{
                                                                            setCommitBtn("newCommit");
                                                                            handleOpenDialog(
                                                                                entry?.data
                                                                            )
                                                                        }}>
                                                                        Freeze
                                                                    </Button>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </TableCell>
                                                        </React.Fragment>
                                                    );
                                                }
                                            )}
                                        </TableRow>
                                    );
                                }
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            {/*--END-- Table 2 - New Add-on Data Freezz */}

            {/* START: This is the log section */}
            {/*<Paper className={classes.paperWrapper}>
                    <Typography className={classes.title}>
                        The following leads are in the approval queue.
                    </Typography>
        
                    <TableContainer className={classes.paper} elevation={3}>
                    <TableContainer className={classes.tableContainer}>
                        <Table className={classes.table} size="small">
                        <TableHead>
                            <TableRow>
                            <StyledTableCell>Sl. No.</StyledTableCell>
                            <StyledTableCell>Project No</StyledTableCell>
                            <StyledTableCell>Lead No</StyledTableCell>
                            <StyledTableCell>Value(INR)</StyledTableCell>
                            <StyledTableCell>City</StyledTableCell>
                            <StyledTableCell>Exp Ctr. Name</StyledTableCell>
                            <StyledTableCell>Sales Won Date</StyledTableCell>
                            <StyledTableCell>Projected Design Sign-off Date (Committed Date)</StyledTableCell>
                            <StyledTableCell>Projection DSO Commited At</StyledTableCell>
                            <StyledTableCell>DSO Month Change</StyledTableCell>
                            <StyledTableCell>Approval Stage</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {approvalLog
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, i) => (
                                <StyledTableRow key={row?._id || i}>
                                <StyledTableCell>{page * rowsPerPage + i + 1}</StyledTableCell> 
                                <StyledTableCell>
                                    {row?.erpProjectNo && row._id ? (
                                        <a
                                            href={`/project-logs/${row._id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: "rgba(0, 0, 0, 0.87)",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            {row.erpProjectNo}
                                        </a>
                                    ) : (
                                        row?.erpProjectNo || "NA"
                                    )}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {row?.lead_no && row._id ? (
                                        <a
                                            href={`/project-logs/${row._id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: "rgba(0, 0, 0, 0.87)",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            {row.lead_no}
                                        </a>
                                    ) : (
                                        row?.lead_no || "NA"
                                    )}
                                </StyledTableCell>
                                <StyledTableCell>{row?.staticSalesWonBudget}</StyledTableCell>
                                <StyledTableCell>{row?.cityName}</StyledTableCell>
                                <StyledTableCell>{row?.experienceCenterName}</StyledTableCell>
                                <StyledTableCell>{moment(row?.leadWonDate).format("DD-MM-YYYY")}</StyledTableCell>
                                <StyledTableCell>
                                    {row?.projectionDSOCommitedDate
                                    ? moment(row.projectionDSOCommitedDate).format("DD-MM-YYYY")
                                    : "N/A"}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {row?.projectionDSOCommitedUpdatedAt
                                    ? moment(row.projectionDSOCommitedUpdatedAt).format("DD-MM-YYYY")
                                    : "N/A"}
                                </StyledTableCell>
        
                                <StyledTableCell>
                                    {row?.designHealthSecondApprovalsDate
                                    ? moment(row.designHealthSecondApprovalsDate).format("DD-MM-YYYY")
                                    : "N/A"}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {row?.designHealthFirstApprovals
                                        ? row.designHealthFirstApprovals
                                        : row?.designHealthSecondApprovals
                                        ? row.designHealthSecondApprovals
                                        : "Send For Approval"
                                    }
                                </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        </Table>
                    </TableContainer>
        
                    <div className={classes.bottomActions}>
                        <TablePagination
                        component="div"
                        count={approvalLog.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </div>
                    </TableContainer>
            </Paper>*/}
            {/* END: This is the log section */}

            {/* Remarks Dialog */}
            <Dialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                maxWidth='sm'
                fullWidth>
                <DialogTitle>Enter Project Details</DialogTitle>
                <DialogContent>
                    {/* Toggle Button */}
                    <Box
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        mb={1}>
                        <Typography variant='subtitle2' style={{ fontWeight: "bold", fontSize: 16 }}>
                            Select Projects
                        </Typography>
                        <Button
                            variant='outlined'
                            size='small'
                            onClick={() => setShowProjects((prev) => !prev)}
                            style={{  textTransform: "none", fontWeight: "bold", fontSize: 16, backgroundColor: "#1C375D", borderColor: "#355025", color: "white" }}>
                            {showProjects ? "Hide Projects" : "Show Projects"}
                        </Button>
                    </Box>

                    {/* Project Table */}
                    {showProjects && (
                        <Box
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: 4,
                                maxHeight: 200,
                                overflowY: "auto",
                                marginBottom: 16,
                            }}>
                            <Table size='small' stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding='checkbox'>
                                            <Checkbox
                                                checked={
                                                    selectedProjects.length ===
                                                    projectList.length
                                                }
                                                indeterminate={
                                                    selectedProjects.length >
                                                        0 &&
                                                    selectedProjects.length <
                                                        projectList.length
                                                }
                                                onChange={
                                                    toggleSelectAllProjects
                                                }
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <strong>S. No.</strong>
                                        </TableCell>
                                        <TableCell>
                                            <strong>Project Name</strong>
                                        </TableCell>
                                        <TableCell>
                                            <strong>DSO Commited Date</strong>
                                        </TableCell>
                                        <TableCell align='right'>
                                            <strong>Value (₹ in Lakh)</strong>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {projectList?.map((project, index) => (
                                        <TableRow key={project.id}>
                                            <TableCell padding='checkbox'>
                                                <Checkbox
                                                    checked={selectedProjects.includes(
                                                        index
                                                    )}
                                                    onChange={() =>
                                                        toggleProjectSelection(
                                                            index
                                                        )
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                <a
                                                    href={`/project-logs/${project?._id}`}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    style={{
                                                        color: "rgba(0, 0, 0, 0.87)",
                                                        textDecoration:
                                                            "underline",
                                                    }}>
                                                    {project?.erpProjectNo}
                                                </a>
                                            </TableCell>
                                            <TableCell align='right'>
                                                {moment(project?.closureDate).format("DD-MM-YYYY")}
                                            </TableCell>
                                            <TableCell align='right'>
                                                {project?.staticSalesWonBudget}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    )}

                    {/* Value Field */}
                    <TextField
                        label='Selected Project Value (₹ in Lakhs)'
                        type='number'
                        fullWidth
                        variant='outlined'
                        value={projectValue}
                        InputProps={{ readOnly: true }}
                        style={{ marginBottom: 16 }}
                    />

                    {/* Freeze Date */}
                    <TextField
                        label="New DSO Date"
                        type="date"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={freezeDate}
                        onChange={(e) => setFreezeDate(e.target.value)}
                        style={{ marginBottom: 16 }}
                        inputProps={{
                            min: getMinDate(),
                            max: getMaxDate(),
                        }}
                    />

                    {/* Remarks */}
                    <TextField
                        label='Remarks'
                        fullWidth
                        multiline
                        minRows={3}
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        variant='outlined'
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseDialog} color='inherit'>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => setConfirmOpen(true)}
                        color="primary"
                        variant="contained"
                        disabled={
                            remarks.trim() === "" ||
                            selectedProjects.length === 0 ||   
                            !projectValue ||
                            !freezeDate
                        }
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
   
            {/* This confirmation popup before submitting */}
            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                <DialogTitle>Confirm Update</DialogTitle>
                <DialogContent>
                    <Typography>
                        {commitBtn === "commit"
                            ? "Are you sure you want to Update the selected project(s)?"
                            : "Are you sure you want to Update again the selected project(s)?"}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)} color="inherit">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            setConfirmOpen(false);  
                            handleSubmit();
                        }}
                        color="primary"
                        variant="contained"
                    >
                        Yes, Update
                    </Button>
                </DialogActions>
            </Dialog>
            {/* This confirmation popup before submitting */}

            {/* Table Popup Modal Start  */}
            <Modal
                open={showDetailedModal}
                onClose={() => setShowDetailedModal(false)}>
                <Box className={classes.modalWrapper}>
                    {/* Header */}
                    <div className={classes.modalHeader}>
                        {/*<Typography variant='h6'>Monthly Contract</Typography> */}
                        <IconButton
                            className={classes.closeButton}
                            onClick={() => setShowDetailedModal(false)}>
                            <CloseIcon />
                        </IconButton>
                    </div>

                    {/* CSV Download */}
                    <div className={classes.csv}>
                        <CSVLink
                            headers={headers}
                            filename={`monthlyContract.csv`}
                            data={csvData}
                            ref={csvButtonRef}
                            style={{ display: "none" }}
                        />
                        <Button
                            onClick={csvDownloadHandler}
                            variant='contained'
                            style={{
                                backgroundColor: "#355025",
                                color: "#FFF2EB",
                            }}>
                            Download CSV
                        </Button>
                    </div>

                    {/* Table Content */}
                    <TableContainer
                        component={Paper}
                        className={classes.tableContainer}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {headers.map((h) => (
                                        <TableCell
                                            key={h.key}
                                            className={classes.headerCell}>
                                            {h.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {csvData.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={headers.length}
                                            align='center'>
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    csvData.map((row, i) => (
                                        <TableRow
                                            key={i}
                                            className={
                                                i % 2 === 0
                                                    ? classes.tableRowEven
                                                    : classes.tableRowOdd
                                            }>
                                            {headers.map((h) => {
                                                const isProjectNo =
                                                    h.key === "projectNo";
                                                const isLeadNo =
                                                    h.key === "leadNo";
                                                return (
                                                    <TableCell
                                                        key={h.key}
                                                        className={
                                                            classes.valueCell
                                                        }>
                                                        {(isProjectNo ||
                                                            isLeadNo) &&
                                                        row._id ? (
                                                            <a
                                                                href={`/project-logs/${row._id}`}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                                style={{
                                                                    color: "rgba(0, 0, 0, 0.87)",
                                                                    textDecoration:
                                                                        "underline",
                                                                }}>
                                                                {row[h.key]}
                                                            </a>
                                                        ) : (
                                                            row[h.key] || "NA"
                                                        )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Modal>
            {/* Popup Modal END  */}
        </>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    FreezeProjects
);
